if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        
        this.innerForm = this.querySelector('.product-form--inner');
        this.isFixed = false;
        this.observeScroll();
      }

      observeScroll() {
        // if (!this.innerForm) return;
      
        // const observer = new IntersectionObserver((entries) => {
        //   if (window.innerWidth < 768) {
        //     entries.forEach((entry) => {
        //       const rect = entry.boundingClientRect;
      
        //       if (!entry.isIntersecting && rect.top < 0 && !this.isFixed) {
        //         this.innerForm.classList.add('transitioning');
        //         this.innerForm.style.transition = 'transform 0.3s ease-in-out';
        //         this.innerForm.style.transform = 'translateY(100%)';
        //         setTimeout(() => {
        //           this.innerForm.classList.add('fixed-bottom');
        //           this.innerForm.style.transform = 'translateY(0)';
        //           this.isFixed = true;
        //         }, 300);
      
        //       } else if (entry.isIntersecting && this.isFixed) {
        //         this.innerForm.style.transition = 'transform 0.3s ease-in-out';
        //         this.innerForm.style.transform = 'translateY(100%)';
        //         setTimeout(() => {
        //           this.innerForm.style.transition = '';
        //           this.innerForm.style.transform = '';
        //           this.innerForm.classList.remove('fixed-bottom');
        //           this.isFixed = false;
        //         }, 100);
        //       }
        //     });
        //   }
        // }, { threshold: 0 });
      
        // observer.observe(this);
      }
      
      validateProperties() {
        const propertiesBlock = document.querySelector('[data-block="properties"]');

        if (!propertiesBlock) return true;

        const inputs = propertiesBlock.querySelectorAll('input');
        let isValid = true;

        inputs.forEach((input) => {
          let inputValid = true;

          if (input.type === 'checkbox') {
            inputValid = input.checked;
          } else {
            inputValid = input.value.trim() !== '';
          }

          input.setAttribute('aria-invalid', !inputValid);

          if (!inputValid) {
            isValid = false;
          }
        });

        if (!isValid) {
          this.handleErrorMessage(window.cartStrings.propError);
        } else {
          this.handleErrorMessage();
        }

        return isValid;
      }

      appendProperties(formData) {
        const propertiesBlock = document.querySelector('[data-block="properties"]');

        if (!propertiesBlock) return;

        propertiesBlock.querySelectorAll('input').forEach((input) => {
          if (!input.name) return;

          if (input.type === 'checkbox') {
            // formData.append(input.name, input.value || 'Taip');
          } else {
            formData.append(input.name, input.value);
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

          
        if (!this.validateProperties()) return;

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.appendProperties(formData);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
